<div #pageContainer class="w-full">
    <form [formGroup]="searchForm">
        <div class="grid grid-cols-2 gap-2">
            <div class="flex justify-start">
                <div class="w-19 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button class="btn btn-outline btn-default dt-download mx-2 group" [matMenuTriggerFor]="downloadMenu">
                    <mat-icon class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                </button>
                <mat-menu #downloadMenu="matMenu">
                    <button mat-menu-item (click)="downloadStringsSummaryExcel()">
                        <span>Excel</span>
                    </button>
                </mat-menu>
            </div>
            <div class="flex justify-end">
                <app-single-filter [searchForm]="searchForm" [filterBy]="'String'"
                    class="text-primary w-64"></app-single-filter>

                <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                    Search
                </button>
                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button class="btn btn-outline btn-default mx-2 group" (click)="setPage({ offset: dt.page.offset })">
                    <mat-icon class="text-primary group-hover:text-white"
                        svgIcon="heroicons_solid:arrow-path"></mat-icon>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-pm-string-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">No</div>

            <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4 my-custom-sort-header">
                Platform
            </div>

            <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                Well String
            </div>

            <div class="border text-center py-8">
                CV
            </div>

            <div class="border text-center py-8">
                SSV
            </div>

            <div class="border text-center py-8">
                LMV
            </div>

            <div class="border text-center py-6">
                Control <br> Line
            </div>

            <div class="border text-center py-8">
                SVLN
            </div>

            <div class="border text-center py-6">
                Prod Csg <br> Valve
            </div>

            <div class="border text-center py-6">
                Surface Csg <br> Valve
            </div>

            <div class="border text-center py-6">
                Conductor Csg <br> Valve
            </div>

            <div class="border text-center py-6">
                PCP <br> (psi)
            </div>

            <div class="border text-center py-6">
                SCP <br> (psi)
            </div>

            <div class="border text-center py-6">
                CCP <br> (psi)
            </div>

            <div class="border text-center py-6">
                ICP <br> (psi)
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn">
                <div class="table-pm-string-summary-grid grid items-center border-b"
                    [ngClass]="{ 'bg-primary-100': i % 2 }">
                    <!-- No -->
                    <div class="py-4 text-center">
                        {{ startingIndex + i + 1 }}.
                    </div>

                    <!-- Platform Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well String Short Name  -->
                    <div class="flex justify-center">
                        {{ row.stringShortName }}
                    </div>

                    <!-- CV Status  -->
                    <div class="flex justify-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.cvStatus)"></div>
                    </div>

                    <!-- SSV Status  -->
                    <div class="text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.ssvStatus)"></div>
                    </div>

                    <!-- LMV Status -->
                    <div class="block text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.lmvStatus)"></div>
                    </div>

                    <!-- Control Line -->
                    <div class="block text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.ctrlLineStatus)"></div>
                    </div>

                    <!-- SVLN -->
                    <div class="block text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.svlnStatus)"></div>
                    </div>

                    <!-- Prod Csg Valve -->
                    <div class="block text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.prodCsgValveStatus)"></div>
                    </div>

                    <!-- Surface Csg Valve -->
                    <div class="block text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.surfCsgValveStatus)"></div>
                    </div>

                    <!-- Conductor Csg Valve -->
                    <div class="block text-center">
                        <div class="circle mx-auto" [ngClass]="getStatusClass(row.condCsgValveStatus)"></div>
                    </div>

                    <!-- PCP -->
                    <div class="block text-center">
                        {{ row.pcp || "-" }}
                    </div>

                    <!-- SCP -->
                    <div class="block text-center">
                        {{ row.scp || "-" }}
                    </div>

                    <!-- CCP -->
                    <div class="block text-center">
                        {{ row.ccp || "-" }}
                    </div>

                    <!-- ICP -->
                    <div class="block text-center">
                        {{ row.icp || "-" }}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no Records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }}
            {{ dt.page.totalRecords <= 1 ? "total" : "totals" }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{ 'pointer-events-none': isLoading }"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
    </div>